import { render, staticRenderFns } from "./RolesTableActions.vue?vue&type=template&id=920d751a"
import script from "./RolesTableActions.vue?vue&type=script&lang=js"
export * from "./RolesTableActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports